import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Chevron Right Circle Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-chevron-right-circle-outline',
    templateUrl: './icon-chevron-right-circle-outline.component.html',
    styleUrls: ['./icon-chevron-right-circle-outline.component.scss'],
    standalone: false
})
export class IconChevronRightCircleOutlineComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;

}
